import React from "react";

export default function Footer() {
  return (
    <footer className="bg-beige-100 py-6 mt-12">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        <span className="text-gray-500 text-sm">
          © {new Date().getFullYear()} Impact Founders. Tous droits réservés.
        </span>
        <div className="flex space-x-4 mt-2 md:mt-0">
          {/* Ajoute ici des liens réseaux sociaux ou mentions légales si besoin */}
          <a href="https://www.linkedin.com/company/impactfounders/" target="_blank" rel="noreferrer" className="text-gray-400 text-sm">
            Linkedin
          </a>
          <a href="/mentions-legales" className="text-gray-400 text-sm">
            Mentions légales
          </a>
        </div>
      </div>
    </footer>
  );
}
